import { LoginService,ValidateFacebookLogin } from './service';

import {
    LOGIN_DATA,
    FACEBOOK_LOGIN,
    LOGIN_TWITTER_DATA,
    LOGIN_STARTUP_INDIA_DATA
} from '../../../common/constants/actionConstants';

import { isLoading } from '../../../common/dependencies/action/action';

export const getvalidateTwitter = (auth_token, auth_verifier) => async (dispatch) => {
    dispatch(isLoading(true))
    return getBindTwitterData(auth_token,auth_verifier).then((data) => {
        const {  loginData} = data;
        //
       if (loginData) {
            dispatch({
                type: LOGIN_TWITTER_DATA,
                payload: loginData
            })
        }
        dispatch(isLoading(false))
    })
}
    export const getLoginData = (params) => async (dispatch) => {
    //
    dispatch(isLoading(true))
    return getBindLoginData(params).then((data) => {
        const {  loginData} = data;
        //
       if (loginData) {
            dispatch({
                type: LOGIN_DATA,
                payload: loginData
            })
        }
        dispatch(isLoading(false))
    })
}

// export const getvalidateTwitter = (auth_token, auth_verifier) => async (dispatch) => {
//     dispatch(isLoading(true))
//     return getBindTwitterData(auth_token,auth_verifier).then((data) => {
//         const {  loginData} = data;
//         //
//        if (loginData) {
//             dispatch({
//                 type: LOGIN_TWITTER_DATA,
//                 payload: loginData
//             })
//         }
//         dispatch(isLoading(false))
//     })
// }
export const getFacebookLoginData = (params) => async (dispatch) => {
    //
    dispatch(isLoading(true))
    return getBindFaceBookLoginData(params).then((data) => {
        const {loginData} = data;
        //
       if (loginData) {
            dispatch({
                type: FACEBOOK_LOGIN,
                payload: loginData
            })
        }
        dispatch(isLoading(false))
    })
}

async function getBindLoginData(params) {
    const loginData = await LoginService.getLoginServiceData(params).catch(e => { return { data: [], status: false } });
   
    return { loginData}
}

async function getBindFaceBookLoginData(params) {
    const loginData = await ValidateFacebookLogin.validateFacebookLogin(params).catch(e => { return { data: [], status: false } });
   
    return { loginData}
}
async function getBindTwitterData(auth_token,auth_verifier) {
    const loginData = await LoginService.validatetwitter(auth_token,auth_verifier).catch(e => { return { data: [], status: false } });
   
    return { loginData}
}
export const validateStartupIndia = (params) => (dispatch) => {
    dispatch(isLoading(true));
    return getBindValidateStartupIndia(params).then((data) => {
      const { loginData } = data;
      
      if (loginData) {
        dispatch({
          type: LOGIN_STARTUP_INDIA_DATA,
          payload: loginData,
        });
      }
      dispatch(isLoading(false));
    });
  };
  async function getBindValidateStartupIndia(params) {
    const loginData =
      await LoginService.ValidateStartupIndiaLogin(params).catch((e) => {
        return { data: "", status: false };
      });
    return {
        loginData,
    };
  }


//   export const getCountersHours = (params) => (dispatch) => {
//     dispatch(isLoading(true));
//     return getBindDataCounterHours(params).then((data) => {
//       const { getCountersHours } = data;
//       if (getCountersHours) {
//         dispatch({
//           type: VIEW_COUNTER_HOURS,
//           payload: getCountersHours,
//         });
//       }
//       dispatch(isLoading(false));
//     });
//   };
//   async function getBindDataCounterHours(params) {
//     const getCountersHours =
//       await AdminDashboardServices.getCountersHours(params).catch((e) => {
//         return { data: [], status: false };
//       });
//     return {
//       getCountersHours,
//     };
//   }
  
  
// export const validateStartupIndia = (auth_token) => async (dispatch) => {
//     dispatch(isLoading(true))
//     return getBindValidateStartupIndia(auth_token).then((data) => {
//         const {  loginData} = data;
//         //
//         
//        if (loginData) {
//             dispatch({
//                 type: LOGIN_STARTUP_INDIA_DATA,
//                 payload: loginData
//             })
//         }
//         dispatch(isLoading(false))
//     })
// }

// async function getBindValidateStartupIndia(auth_token) {
//     const loginData = await LoginService.ValidateStartupIndiaLogin(auth_token).catch(e => { return { data: [], status: false } });
   
//     return { loginData}
// }